// extracted by mini-css-extract-plugin
export default {"about-container":"about_about-container__FU1RA"};